"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleOrderLabFormToPayloadDataHandler = void 0;
const domain_1 = require("@home-health-notify/domain");
const dayjs_1 = __importDefault(require("dayjs"));
const scheduleOrderLabFormToPayloadDataHandler = (labs, allLabTests) => (data) => {
    let insuranceInformation;
    const insurancePolicyType = data.insuranceInformation.policyType;
    if (insurancePolicyType === "Medicare") {
        insuranceInformation = {
            policyType: "Medicare",
            mbi: data.insuranceInformation.mbi,
        };
    }
    else if (insurancePolicyType === "Managed Medicare") {
        insuranceInformation = {
            policyType: "Managed Medicare",
            policyNumber: data.insuranceInformation.policyNumber,
            policyProvider: data.insuranceInformation.policyProvider,
        };
    }
    else {
        throw new Error(`Panic: unsupported payment method: ${insurancePolicyType}`);
    }
    const formattedCollectionDate = (0, dayjs_1.default)(data.specimenInformation.collectionDate).format(domain_1.HHNConstants.SERVER_DATE_FORMAT);
    let specimenInformation;
    const requisitionType = data.specimenInformation.requisitionType;
    if (requisitionType === "Lab Collection Request") {
        specimenInformation = {
            requisitionType: "Lab Collection Request",
            collectionDate: formattedCollectionDate,
            collectionTimeZone: "America/New_York",
            collectionTime: data.specimenInformation.collectionTime,
        };
    }
    else if (requisitionType === "Collected by Facility") {
        specimenInformation = {
            requisitionType: "Collected by Facility",
            collectionDate: formattedCollectionDate,
            collectionTimeZone: "America/New_York",
            collectionTime: data.specimenInformation.collectionTime,
        };
    }
    else if (requisitionType === "Standing Order") {
        specimenInformation = {
            requisitionType: "Standing Order",
            collectionTimeZone: "America/New_York",
            collectionDate: formattedCollectionDate,
            collectionTime: data.specimenInformation.collectionTime,
            collectionFrequency: data.specimenInformation.collectionFrequency,
            collectionDays: data.specimenInformation.collectionDays,
            terminationDate: (0, dayjs_1.default)(data.specimenInformation.terminationDate).format(domain_1.HHNConstants.SERVER_DATE_FORMAT),
        };
    }
    else {
        throw new Error(`Panic: unsupported requisition type: ${requisitionType}`);
    }
    const tests = data.tests.map(t => {
        const { loincCode, specimenType } = JSON.parse(t.labTest);
        const labTest = allLabTests.find(lt => lt.loincCode === loincCode &&
            (!specimenType || lt.specimenType === specimenType));
        if (!labTest) {
            throw new Error("Unexepected! test should always have a name and type");
        }
        return {
            loincCode: labTest.loincCode,
            type: labTest.type,
            specimenType: labTest.specimenType,
            specimenSource: labTest.specimenSource,
        };
    });
    const diagnosis = data.diagnosis.map(t => {
        const parsedDiagnosis = JSON.parse(t.icdCode);
        return { code: parsedDiagnosis.value, name: parsedDiagnosis.label };
    });
    const lab = labs.find(l => l.id === data.labInformation.labId);
    const formattedDateOfBirth = (0, dayjs_1.default)(data.patientInformation.dateOfBirth).format(domain_1.HHNConstants.SERVER_DATE_FORMAT);
    return {
        form: {
            id: data.id,
            labId: lab.id,
            providerNPI: data.providerInformation.providerNPI,
            specimenInformation: specimenInformation,
            tests: tests,
            diagnosis: diagnosis,
            comments: data.comments,
            patientInformation: {
                id: data.patientInformation.id,
                firstName: data.patientInformation.firstName,
                lastName: data.patientInformation.lastName,
                gender: data.patientInformation.gender,
                roomNo: data.patientInformation.roomNo,
                dateOfBirth: formattedDateOfBirth,
                addressOne: data.patientInformation.addressOne,
                addressTwo: data.patientInformation.addressTwo,
                city: data.patientInformation.city,
                state: data.patientInformation.state,
                zipCode: data.patientInformation.zipCode,
                countryCode: "+1",
                phoneNumber: data.patientInformation.phoneNumber,
            },
            insuranceInformation: insuranceInformation,
        },
    };
};
exports.scheduleOrderLabFormToPayloadDataHandler = scheduleOrderLabFormToPayloadDataHandler;
